module.exports = __webpack_public_path__ + "img/vuefordesigners.603961a7.gif";